module.exports = __webpack_public_path__ + "img/north-bound.707ceba2.svg";